import { formatPrice } from 'settings/app/helpers'
import { Icon } from 'components/atoms'

const stringForKey = {
  freeParking: 'kostenfreie Parkplätze vorhanden',
  dedicatedParking: 'klinikeigene Parkplätze vorhanden',
  parkingCostsPerHour: (val) =>
    `Parkplatzkosten pro Stunde ${ formatPrice({ price: val / 100 }) }`,
  parkingCostsPerDay: (val) =>
    `Parkplatzkosten pro Tag ${ formatPrice({ price: val / 100 }) }`,
}

export const HospitalParkingInformation = ({ accessibility }) => {
  const hasAccessibility =
    accessibility && Object.keys(stringForKey).some((key) => accessibility[key])

  if (!hasAccessibility) {
    return null
  }

  const parkingStrings = Object.entries(stringForKey)
    .filter(([key]) => accessibility[key])
    .map(([key, stringOrFunction]) => {
      const accessibilityValue = accessibility[key]
      return typeof stringOrFunction === 'function'
        ? stringOrFunction(parseInt(accessibilityValue.toString(), 10))
        : stringOrFunction
    })

  return (
    <li
      className='accessibility-list-item'
      data-cy='accessibility-list-item'
      data-cy-accessibility-type='freeParking'
      data-cy-accessibility-value={ parkingStrings.join(', ') }>
      <Icon className={ `icon-f-parking` } />
      <p>{parkingStrings.join(', ')}</p>
    </li>
  )
}
